import { useMemo } from 'react';
import { trpc } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery, type AppQueryErrorConfig } from './useAppQuery';

/**
 * Shared query for the user's entity lists with the app-standard retry and
 * stale time. Mutations invalidate this query's key explicitly, so the stale
 * time is safe.
 */
export const useEntityLists = (options?: { enabled?: boolean; errorConfig?: AppQueryErrorConfig }) => {
    const query = useAppQuery(
        {
            ...trpc.user.fetchEntityLists.queryOptions(),
            enabled: options?.enabled,
            staleTime: DEFAULT_REQUISITIES_STALE_TIME
        },
        options?.errorConfig
    );

    const entityLists = useMemo(() => query.data?.entityLists ?? [], [query.data?.entityLists]);

    return { entityLists, error: query.error, isLoading: query.isLoading, query };
};
